import React from 'react';

export const weddingFeatureUpsellCaptions = {
  photo_watermark_enabled: {
    title:
      'Edit your wedding hashtag, add a custom photo overlay, and unlock more features',
  },
  join_code_enabled: {
    title: 'Upgrade your event to unlock custom join code!',
    subtitle: (
      <p>
        With WaldoWed Gold or Platinum, unlock custom join code for your
        wedding, along with many other wonderful features &ndash; like having
        100GB of dedicated storage, face finding for every guest, Video
        Guestbook, and more!
      </p>
    ),
  },
  slideshow_enabled: {
    title: 'Upgrade your event to unlock live slideshows!',
    subtitle: (
      <p>
        With WaldoWed Platinum, unlock live slideshows for your wedding, along
        with many other wonderful features &ndash; like having 100GB of
        dedicated storage, face finding for every guest, Video Guestbook, and
        more!
      </p>
    ),
  },
  joins_enabled: {
    illustration: '/wedding_matches_feature_upsell.png',
    title: (
      <>
        Upgrade your event to activate face
        <br />
        finding for EVERY guest!
      </>
    ),
    subtitle: (
      <p>
        With WaldoWed Gold or Platinum, face finding is activated for every
        guest, along with many other wonderful features &ndash; like having
        100GB of dedicated storage, live slideshows, Video Guestbook, and more!
      </p>
    ),
  },
  video_guestbook_enabled: {
    title: 'Get WaldoWed Platinum to enjoy your Video Guestbook!',
    subtitle: (
      <p>
        With WaldoWed Platinum, you can invite others to share their well wishes
        in your Video Guestbook, and unlock many other wonderful features
        &ndash; like having 100GB of dedicated storage, live slideshows, and
        more!
      </p>
    ),
  },
  memory_book_enabled: {
    title: 'Get WaldoWed Platinum to enjoy your Memories Slideshow!',
    subtitle: (
      <p>
        With WaldoWed Platinum, you can turn old memories into a smart slideshow
        in your Memories Slideshow, and unlock many other wonderful features
        &ndash; like having 100GB of dedicated storage, video guest book and
        more!
      </p>
    ),
  },
  members_view_enabled: {
    title: 'Upgrade your event to see who has joined your gallery!',
    subtitle: (
      <p>
        With WaldoWed Gold or Platinum, you can see who has joined your events
        to find their photos, along with many other wonderful features &ndash;
        like having 100GB of dedicated storage, live slideshows, Video
        Guestbook, and more!
      </p>
    ),
  },
  custom_tags_enabled: {
    title: 'Upgrade your event to unlock custom tags!',
    subtitle: (
      <p>
        With WaldoWed Gold or Platinum, you can customize tags on albums and
        photos, and unlock many other wonderful features &ndash; like having
        100GB of dedicated storage, live slideshows, Video Guestbook, and more!
      </p>
    ),
  },
  face_highlights_enabled: {
    title:
      'Upgrade to WaldoWed Gold or Platinum and unlock photo spotlighting!',
    subtitle: (
      <p>
        With spotlights, you can easily curate great photos of others and export
        them from your dashboard!
      </p>
    ),
  },
  white_label_marketing_prints_enabled: {
    title: 'Remove watermark and unlock more features',
  },
  qr_code_enabled: {
    title: 'Unlock more design options & remove Waldo branding',
  },
};
